var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { firstNameLastNameFromName } from "../../utils.mjs";
let stripePromise;
export const loadStripeIfNeeded = (cartPayment) => __awaiter(void 0, void 0, void 0, function* () {
    if (!stripePromise) {
        stripePromise = loadStripe(cartPayment);
    }
    return stripePromise;
});
const loadStripe = (cartPayment) => __awaiter(void 0, void 0, void 0, function* () {
    const stripeModule = yield import('@stripe/stripe-js');
    const stripe = yield stripeModule.loadStripe(cartPayment.apiKey);
    if (!stripe) {
        throw new Error('Failed to load Stripe');
    }
    return stripe;
});
export const getAddresses = (confirmEvent) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    const name = firstNameLastNameFromName((_b = (_a = confirmEvent.billingDetails) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
    let address = {
        firstName: name.firstName,
        lastName: name.lastName,
        address1: (_e = (_d = (_c = confirmEvent.billingDetails) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.line1) !== null && _e !== void 0 ? _e : '',
        address2: (_h = (_g = (_f = confirmEvent.billingDetails) === null || _f === void 0 ? void 0 : _f.address) === null || _g === void 0 ? void 0 : _g.line2) !== null && _h !== void 0 ? _h : '',
        city: (_l = (_k = (_j = confirmEvent.billingDetails) === null || _j === void 0 ? void 0 : _j.address) === null || _k === void 0 ? void 0 : _k.city) !== null && _l !== void 0 ? _l : '',
        postalCode: (_p = (_o = (_m = confirmEvent.billingDetails) === null || _m === void 0 ? void 0 : _m.address) === null || _o === void 0 ? void 0 : _o.postal_code) !== null && _p !== void 0 ? _p : '',
        stateOrProvince: (_s = (_r = (_q = confirmEvent.billingDetails) === null || _q === void 0 ? void 0 : _q.address) === null || _r === void 0 ? void 0 : _r.state) !== null && _s !== void 0 ? _s : '',
        isValid: true, // We trust that Stripe has collected a valid address
    };
    let billingAddress = undefined;
    if (confirmEvent.shippingAddress) {
        billingAddress = address;
        const shippingName = firstNameLastNameFromName((_t = confirmEvent.shippingAddress.name) !== null && _t !== void 0 ? _t : '');
        address = {
            firstName: shippingName.firstName,
            lastName: shippingName.lastName,
            address1: (_u = confirmEvent.shippingAddress.address.line1) !== null && _u !== void 0 ? _u : '',
            address2: (_v = confirmEvent.shippingAddress.address.line2) !== null && _v !== void 0 ? _v : '',
            city: (_w = confirmEvent.shippingAddress.address.city) !== null && _w !== void 0 ? _w : '',
            postalCode: (_x = confirmEvent.shippingAddress.address.postal_code) !== null && _x !== void 0 ? _x : '',
            stateOrProvince: (_y = confirmEvent.shippingAddress.address.state) !== null && _y !== void 0 ? _y : '',
            isValid: true, // We trust that Stripe has collected a valid address
        };
    }
    return { address, billingAddress };
};
export const getShippingAddress = (details) => {
    var _a, _b, _c;
    return {
        firstName: (_a = details.value.firstName) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = details.value.lastName) !== null && _b !== void 0 ? _b : '',
        address1: details.value.address.line1,
        address2: (_c = details.value.address.line2) !== null && _c !== void 0 ? _c : undefined,
        city: details.value.address.city,
        postalCode: details.value.address.postal_code,
        stateOrProvince: details.value.address.state,
        isValid: true,
    };
};
export const getBillingAddress = (details) => {
    return Object.assign(Object.assign({}, getShippingAddress(details)), { countryCode: details.value.address.country.toLowerCase() });
};
//# sourceMappingURL=utils.js.map